export default function toObjectRecursive(map) {
  var object = {};

  if (map instanceof Map) {
    map.forEach(function (obj, key) {
      object[key] = obj.toObject();
    });
  } else {
    Object.keys(map).forEach(function (key) {
      object[key] = map[key].toObject();
    });
  }

  return object;
}